import { AxiosRequestConfig } from 'axios';
import { EmeraldRequestParams } from 'src/common/interfaces/requests/EmeraldRequestParams';
import { emeraldRequest } from 'src/common/api/emerald-request';
import { IReceipt } from 'src/common/interfaces/dtos/IReceipt';
import { EwicPrintDTO } from 'src/tendering/interfaces/ewic-print.dto';

export const getEwicBalanceInquiryReceipt = async (
  ewicBalanceData: EwicPrintDTO,
): Promise<IReceipt[]> => {
  const axiosConfig: AxiosRequestConfig = {
    url: `/ewic/balance-inquiry-receipt`,
    method: 'POST',
    data: ewicBalanceData,
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: false,
    showLoggingInfo: true,
  };

  return emeraldRequest<IReceipt[]>(emeraldRequestParams);
};
